import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@components/ui/dropdown-menu";
import { ROUTES } from "@/routes_new";
import { Trans } from "@lingui/react/macro";
import { Organization } from "@/types/Organization";
import { User } from "@/types/User";

export function StaffActions({
  organization,
  defaultOrganization,
  orgUuid,
}: {
  organization: Organization | null;
  defaultOrganization: User["default_organization"] | null;
  orgUuid: string;
}) {
  const defaultOrganizationName = defaultOrganization?.name;
  const organizationName = organization?.name;

  return (
    <>
      <DropdownMenuSeparator />

      {defaultOrganization &&
        defaultOrganizationName &&
        defaultOrganization.uuid !== orgUuid && (
          <>
            <DropdownMenuItem asChild className="gap-1">
              <a
                href={ROUTES.APP_HOME_ORGID.replace(
                  ":orgUuid",
                  defaultOrganization.uuid
                )}
              >
                <Trans>
                  Gå till
                  <span className="font-semibold">
                    {defaultOrganizationName}
                  </span>
                </Trans>
              </a>
            </DropdownMenuItem>
          </>
        )}

      {organization && organizationName && (
        <DropdownMenuItem asChild className="gap-1">
          <a href={`/internal/konton/${organization.id}/`}>
            <Trans>
              Redigera
              <span className="font-semibold">{organizationName}</span>
            </Trans>
          </a>
        </DropdownMenuItem>
      )}

      <DropdownMenuItem asChild>
        <a href="/internal/konton/new">
          <Trans>Skapa nytt konto</Trans>
        </a>
      </DropdownMenuItem>
    </>
  );
}
